module.exports = __webpack_public_path__ + "img/hand-left.79ed3fcb.svg";